import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTIONS, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
} from "./actions"

export function ProjectQaWeldingInspectionsAccessRestrictionsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTIONS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsAccessRestrictionsReducer } from "modules/project/qa/welding_inspections/access_restrictions/reducer"

// project_qa_welding_inspections_access_restrictions:ProjectQaWeldingInspectionsAccessRestrictionsReducer,
